import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { BUSCAR_PEDIDO } from '../types';

export default function buscarPedido (idPedido, idEmpresa) {
  const url = `${URL}/pedido/${idPedido}/empresa/${idEmpresa}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_PEDIDO,
        payload: response

      })
  );
}
